import React, { useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import NavigationTabs from "../../../components/Globo/Tabs/NavigationTabs";
import { usePermissionCatalog } from "../../../hooks/usePermissionCatalog";
import UserProfileResourceView from "./UserProfileResourceView";
import ResourceProfileUserView from "./ResourceProfileUserView";
import ProfileResourceView from "./ProfileResourceView";
import { FONT_INTER } from "../../../styles/fonts";

const VIEWS = [
  { value: "user-profile-resource", label: "Usuário → Perfil → Recurso" },
  { value: "resource-profile-user", label: "Recurso → Perfil → Usuário" },
  { value: "profile-resource", label: "Perfil ↔ Recurso" },
];

// Gerencia a associação Perfil × Recurso (nunca o Usuário em si) através de 3 visões, alternadas
// por uma navegação interna. O catálogo de perfis/recursos é carregado uma única vez aqui e
// compartilhado entre as visões, que só trocam ao alternar a navegação (cada troca desmonta a
// visão anterior, o que já reseta as seleções de coluna dela).
const UserManagement = () => {
  const [view, setView] = useState(VIEWS[0].value);
  const {
    profiles,
    profilesByName,
    resources,
    loading,
    error,
    patchProfileResources,
  } = usePermissionCatalog();

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
      <NavigationTabs
        tabs={VIEWS}
        value={view}
        onChange={setView}
        sx={{ mb: 2, flexShrink: 0 }}
      />

      <Box sx={{ flex: 1, minHeight: 0 }}>
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
            <CircularProgress sx={{ color: "#185CFB" }} />
          </Box>
        )}

        {!loading && error && (
          <Typography
            sx={{
              fontFamily: FONT_INTER,
              color: "#e5254e",
              textAlign: "center",
              py: 8,
            }}
          >
            Não foi possível carregar o catálogo de perfis e recursos. Tente
            novamente mais tarde.
          </Typography>
        )}

        {!loading && !error && view === "user-profile-resource" && (
          <UserProfileResourceView profilesByName={profilesByName} />
        )}

        {!loading && !error && view === "resource-profile-user" && (
          <ResourceProfileUserView
            resources={resources}
            profilesByName={profilesByName}
          />
        )}

        {!loading && !error && view === "profile-resource" && (
          <ProfileResourceView
            profiles={profiles}
            resources={resources}
            patchProfileResources={patchProfileResources}
          />
        )}
      </Box>
    </Box>
  );
};

export default UserManagement;
